import { LatestNewsItem } from "shared/request/myHealthyAdvantageApi";

export const WhatsNewItem = ({ item }: { item: LatestNewsItem }) => (
  <div data-testid="whats-new-item" className="flex flex-col items-center justify-between mb-4 text-center">
    <div className="h-[200px] w-full">
      <img
        className="object-contain w-full h-full"
        sizes="(max-width: 768px) 176px, (max-width: 1024px) 264px, (max-width: 1280px) 352px, 352px"
        srcSet={item.image.srcSet}
        alt={item.image.alt}
      />
    </div>
    <div className="px-7">
      <h2>{item.title}</h2>
      <p>{item.description}</p>
    </div>
  </div>
);
